import title from './title';

export default dsf.component({
  name: 'DsfTitle2',
  mixins: [title],
  ctrlCaption: "标题2",
  props: {
    value: {
      type: [String, Number],
      default: '标题2'
    },
    fontType: {
      type: Number,
      default: 2
    }
  }
});